// extracted by mini-css-extract-plugin
module.exports = {"vehicleAdditional":"styles_vehicleAdditional__1m1xY"};